import api from '@/api/users'
import errors from '@/api/errors'

const state = {
  internal: {
    isUserInfoLoaded: false,
    isUserInfoLoaded2: false
  },
  user: {},
  user2: {}
}

const getters = {
  targetUser: state => state.internal.targetUser,
  user: state => state.user,
  user2: state => state.user2,
  isUserInfoLoaded: state => state.internal.isUserInfoLoaded,
  isUserInfoLoaded2: state => state.internal.isUserInfoLoaded2
}

const mutations = {
  initialize: (state, args) => {
    Object.assign(state.internal, args)
  },
  setUser: (state, user) => {
    state.user = user
    state.internal.isUserInfoLoaded = true
  },
  setUser2: (state, user) => {
    state.user2 = user
    state.internal.isUserInfoLoaded2 = true
  },
  setEntryFollow: (state, status) => {
    const newUser = Object.assign({}, state.user)
    newUser.is_entry_follow = status.isEntryFollow
    newUser.is_entry_follow_id = status.followId
    state.user = newUser
  },
  registUserNickname: (state, args) => {
    state.user.nickname = args.nickname
  }
}

const actions = {
  /**
   * 初期化
   */
  initialize: ({ commit }, args) => {
    commit('initialize', args)
  },
  /**
   * ユーザー取得
   */
  getUser: ({ dispatch, commit }, args) => {
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      targetUser: args.targetUser
    }
    return api.getUser(params).then(data => {
      commit('setUser', data)
    }).catch(error => {
      dispatch('commons/setGlobalError', error, { root: true })
    })
  },
  /**
   * ユーザー取得
   */
  getUser2: ({ dispatch, commit }, args) => {
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      targetUser: args.targetUser
    }
    return api.getUser(params).then(data => {
      commit('setUser2', data)
    }).catch(error => {
      dispatch('commons/setGlobalError', error, { root: true })
    })
  },
  /**
   * フォロー登録/解除
   */
  setEntryFollow: ({ commit }, status) => {
    commit('setEntryFollow', status)
  },
  /**
   * ニックネーム登録チェック
   */
  checkNicknameDuplicate: ({ dispatch, commit }, nickname) => {
    dispatch('commons/clearGlobalError', {}, { root: true })
    return api.checkUserNickname(nickname).catch(error => {
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  /**
   * ニックネーム登録
   */
  setUserNickname: ({ dispatch, commit }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      nickname: args.nickname
    }
    return api.registUserNickname(params).then(result => {
      if (result.resultCode !== 104) {
        commit('registUserNickname', args)
      }
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      return result
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js